import {useEffect, useState} from "react";
import {getReactify, getYmaps3React} from "shared/consts";

export const useReactify = (VITE_YANDEX_TOKEN: string) => {
  const [reactify, setReactify] = useState<any>(null);
  
  const getMaps = async () => {
    const ymaps3React = await getYmaps3React()
    if (!ymaps3React) return null;
    const reactifyObject = await getReactify(ymaps3React)
    setReactify(reactifyObject)
  }
  
  useEffect(() => {
    if (!VITE_YANDEX_TOKEN) return
    getMaps()
  }, [VITE_YANDEX_TOKEN]);
  
  return reactify
}